import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'eui-toolbar-logo',
    templateUrl: './toolbar-logo.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
    host: {
        '(click)': 'onClick()',
    },
})
export class EuiToolbarLogoComponent {

    @HostBinding() class = 'eui-toolbar-logo';

    @Input() homeUrl = '..';

    constructor(
        private router: Router,
    ) {}

    onClick() {
        this.router.navigate([this.homeUrl]);
    }
}
